import { useParams, Link } from "react-router-dom";
import { ArrowLeft, CalendarDays } from "lucide-react";
import { getBlog } from "@/lib/content";
import Cta from "@/components/Cta";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
}

export default function BlogDetail() {
  const { slug } = useParams();
  const post = getBlog(slug);

  if (!post)
    return (
      <div className="max-w-3xl mx-auto px-4 py-32 text-center">
        <h1 className="font-heading text-3xl font-bold text-[#2C3E50]">Blogpost niet gevonden</h1>
        <Link to="/blog" className="mt-6 inline-block text-[#FF6B35] font-semibold">
          Terug naar blog
        </Link>
      </div>
    );

  return (
    <div data-testid="blog-detail-page">
      <section className="relative h-[42vh] min-h-[320px] overflow-hidden">
        <img src={post.image} alt={post.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2C3E50]/70" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-10 text-white">
            <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-slate-200 hover:text-white mb-4">
              <ArrowLeft size={15} /> Terug naar blog
            </Link>
            <div className="flex items-center gap-2 text-xs mb-3">
              <span className="bg-[#FF6B35] font-semibold px-2.5 py-1 rounded-full">{post.category}</span>
              <span className="inline-flex items-center gap-1 text-slate-200">
                <CalendarDays size={13} /> {formatDate(post.published_at)}
              </span>
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-black tracking-tight">{post.title}</h1>
          </div>
        </div>
      </section>

      <article
        data-testid="blog-content"
        className="prose-tixter max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14"
        dangerouslySetInnerHTML={{ __html: post.content }}
      />

      <Cta
        title="Bespaar nu op tickets!"
        text="Bekijk de actuele deals en boek via onze betrouwbare partners."
        buttons={[
          { to: "/concerttickets", label: "Bekijk Concerttickets" },
          { to: "/festivaltickets", label: "Bekijk Festivaltickets" },
        ]}
      />
    </div>
  );
}
